import { useEffect, useState } from 'react';
import { getReceipts, getReceiptTypes } from '../../../usecases/receipts-usecase'; 
import Tablas from '../../molecules/tablas/view'; // Import the Tablas molecule 
import './style.css'; 
import { EmptyArray } from '../../../domain/empty/model';

const ReceiptTable = () => {
  
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [receipts, setReceipts] = useState({
        data: [],
        page: 1,
        page_size: 50,
        total: 0,
    });  

  useEffect(() => {
    fetchData();
  }, []); 

  const headersList = [    
    "date", 
    "description", 
    "consecutive", 
    "value", 
    "receipt_type",
  ];

  const mapper = (data, types = []) => {
    return data.map(item => ({
      date: item.date,
      description: item.description,
      consecutive: item.number,
      value: item.amount,
      receipt_type: types.find(tp => tp.id == item.receipt_type_id)?.name || 'General',
    }))
  }

  const fetchData = async (page=receipts.page, limit=receipts.page_size) => {
    setIsLoadingData(true);
    const receipt_types = await getReceiptTypes(1, 1000);
    const types = receipt_types?.data || [];
    setReceiptTypes(types);
    setReceipts(prev => ({...prev, data: undefined}));
    const result = await getReceipts(page, limit);
    if (!result?.data || result.data.length == 0) {
      setReceipts({...result, data: EmptyArray});
    } else {
      setReceipts({...result, data: mapper(result.data, types)});
    }
    setIsLoadingData(false);
  };

  const excludeList = ['id', 'created_at', 'updated_at', 'users_id']; // Exclude these from being displayed directly

  const formats = { 
    date: { type: 'timestamp' },
    value: { type: 'money' }, 
    consecutive: { type: "prefix", prefix: "RC" }, 
  }; 

  return (
    <Tablas
        paginatedData={receipts}
        getFunction={fetchData}
        headersList={headersList}
        excludeList={excludeList}
        formats={formats}
        emptyMessage="No hay recibos para mostrar"
        onReload={fetchData}
        isLoading={isLoadingData}
        allowPageSizeControl={true}
      />
  );
};

export default ReceiptTable;
